/**
 * @generated SignedSource<<94ee2d034c3f7e2f2a2459bf8c81aafa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeShopifyRecurringChargeType = "DAM_MODEL_OPTIMIZATIONS" | "DAM_PREMIUM" | "LARGE_FILES" | "MULTI_ACCOUNT" | "PROFANITY_CHECK" | "QUOTES" | "SALES_CHANNELS" | "STORAGE" | "SWITCH_SALES_CHANNELS" | "VECTORIZER" | "VIEWS" | "VTO";
export type ShopifyChargeConfirmationInput = {
  chargeType: ZakekeShopifyRecurringChargeType;
  shopifyChargeID: string;
};
export type salesChannelConfirmShopifyChargeMutation$variables = {
  input: ShopifyChargeConfirmationInput;
};
export type salesChannelConfirmShopifyChargeMutation$data = {
  readonly confirmShopifyCharge: string;
};
export type salesChannelConfirmShopifyChargeMutation = {
  response: salesChannelConfirmShopifyChargeMutation$data;
  variables: salesChannelConfirmShopifyChargeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "confirmShopifyCharge",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelConfirmShopifyChargeMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelConfirmShopifyChargeMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "195be509a3cb0353ed66e1547775aae1",
    "id": null,
    "metadata": {},
    "name": "salesChannelConfirmShopifyChargeMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelConfirmShopifyChargeMutation(\n  $input: ShopifyChargeConfirmationInput!\n) {\n  confirmShopifyCharge(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "dcf44921886968514955ba6a154683ef";

export default node;
